import awardsOptions from '../util/awardsOptions'

export default () => {
  var $siteSearch = $('.js-siteSearch')

  $('.js-header__searchIconWrapper').click( function (e) {
    e.stopPropagation()
    $siteSearch.addClass('is-active')
    getOptions()

    setTimeout(function() {
      $('.js-siteSearch__input').trigger('focus')
    }, 300 )

    $(document).on('click', function(e) {

      if ($siteSearch[0] !== e.target && !$siteSearch[0].contains(e.target) ) {
        $siteSearch.removeClass('is-active')
      }

    })

  })

  $('.js-siteSearch__closeBtn').click( function () {
    $siteSearch.removeClass('is-active')
  })

  $('.js-siteSearch__searchBtn').on('click', function(e) {
    e.preventDefault()
    const inputValue = $('.js-siteSearch__input').val()
    const cuisine = $('.js-siteSearch__dropdown--cuisine').val()
    const award = $('.js-siteSearch__dropdown--award').val()
    const ambience = $('.js-siteSearch__dropdown--ambience').val()
    const clubOnly = $('.js-siteSearch__checkbox--clubOnly input:checked')
    const type = $('.js-siteSearch__form').find('input[name="type"]:checked').val()


      let link = '/search?sort=nearest'

      if ( inputValue ) {
        link += '&terms='+encodeURIComponent(inputValue)
      }

      if ( cuisine ) {
        link += '&cuisine='+encodeURIComponent(cuisine)
      }

      if ( award ) {
        link += '&award='+encodeURIComponent(award)
      }

      if ( ambience ) {
        link += '&style='+encodeURIComponent(ambience)
      }

      if ( clubOnly && clubOnly.length ) {
        link += '&clubOffersOnly=1'
      }

      if ( type) {
        link += '&type='+encodeURIComponent(type)
      }

      window.open(link, '_self')

  })

  // eslint-disable-next-line
  const baseUrl = `${API_BASE_URL}`
  const $cuisineDropdown = $('.js-siteSearch__dropdown--cuisine')
  const $awardDropdown = $('.js-siteSearch__dropdown--award')
  const $ambienceDropdown = $('.js-siteSearch__dropdown--ambience')

  function getOptions() {

    if ( $siteSearch.hasClass('options-ready') ) return

    const cuisinesPromise = $.ajax({ url: `${baseUrl}/venues/options/cuisines.description` })
    const ambiencesPromise = $.ajax({ url: `${baseUrl}/ordered_ambiences` })

    $.when(cuisinesPromise, ambiencesPromise).then(function (p1, p2) {
      const cuisines = p1[0]
      const ambiences = p2[0]

      $siteSearch.addClass('options-ready')

      if ( cuisines.length ) {
        $cuisineDropdown.html('')
        cuisines.map((item, index) => {
          if ( index === 0 ) {
            $cuisineDropdown.append('<option value="">Cuisine (any)</option')
            $cuisineDropdown.append(`<option value="${item}">${item}</option`)
          } else {
            $cuisineDropdown.append(`<option value="${item}">${item}</option`)
          }
        })
      }
      if ( awardsOptions().length ) {
        $awardDropdown.html('')
        awardsOptions().map((item, index) => {
          if ( index === 0 ) {
            $awardDropdown.append('<option value="" selected>Accolades (any)</option>')
            $awardDropdown.append(`<option value="${item.name}-${item.value}">${item.name}</option`)
          } else {
            $awardDropdown.append(`<option value="${item.name}-${item.value}">${item.name}</option`)
          }
        })
      }
      if ( ambiences.length ) {
        $ambienceDropdown.html('')
        ambiences.map((item, index) => {
          if ( index === 0 ) {
            $ambienceDropdown.append('<option value="" selected>Restaurant Style (any)</option>')
            $ambienceDropdown.append(`<option value="${item}">${item}</option`)
          } else {
            $ambienceDropdown.append(`<option value="${item}">${item}</option`)
          }
        })
      }
    })
  }

}
